var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7988 8.66667V12.6667C14.7988 13.0203 14.6584 13.3594 14.4083 13.6095C14.1583 13.8595 13.8191 14 13.4655 14H4.13216C3.77854 14 3.4394 13.8595 3.18935 13.6095C2.9393 13.3594 2.79883 13.0203 2.79883 12.6667V3.33333C2.79883 2.97971 2.9393 2.64057 3.18935 2.39052C3.4394 2.14048 3.77854 2 4.13216 2H8.13216M14.7988 2L8.79883 8M14.7988 2H10.7988M14.7988 2V6",
    stroke: "#1A1A1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenModal);
export default __webpack_public_path__ + "static/media/openModal.d9afa271b68d28c7be3c0a679dcffaf9.svg";
export { ForwardRef as ReactComponent };